function initCardBuy() {
  try {
		
  } catch {
    console.log("Ошибка initCardBuy");
  }
}
